/** Product type tags (shared pick-list). The server flag decides; this only hides the UI on builds that have it off. */
export const isTypeTagsEnabled = (): boolean =>
  process.env.REACT_APP_TYPE_TAGS_ENABLED === "true" || process.env.REACT_APP_ENV === "loc";
